import toast from "react-hot-toast";
import Success from "./components/success";
import Error from "./components/error";
import Activity from "./components/activity";

const defaultPoition = "bottom-center";

const config = {
  style: {
    borderRadius: 10,
    background: "white",
    padding: 10,
  },
};

const activityIndicatorConfig = {
  ...config,
  position: defaultPoition,
  duration: Infinity,
};

const Notifications = {
  success: function (message, position = defaultPoition) {
    toast(
      (t) => <Success message={message} onClose={() => toast.dismiss(t.id)} />,
      { ...config, position }
    );
  },
  error: function (message, position = defaultPoition) {
    toast(
      (t) => <Error message={message} onClose={() => toast.dismiss(t.id)} />,
      { ...config, position }
    );
  },
  activity: function (message, position = defaultPoition) {
    const id = toast(
      (t) => <Activity message={message} onClose={() => toast.dismiss(t.id)} />,
      { ...activityIndicatorConfig, position }
    );
    return id;
  },

  dismiss: function (toastId) {
    toast.dismiss(toastId);
  },
  clear: function () {
    toast.dismiss();
  },
};

export default Notifications;
